import React from 'react';
import { Box, Text } from '@chakra-ui/react';

interface Props {
  title?: string;
  children: React.ReactNode;
  emptyHint?: string;
  show?: boolean;
  /**
   * When true (in-app player): no inner scroll/padding so the player can use the full column height
   * and element fullscreen fills the viewport correctly.
   */
  fillSlot?: boolean;
}

/** Right column: player, VOD detail, or series. Width comes from parent (resizable split on large screens). */
export function RightDetailPanel({ title, children, emptyHint, show = true, fillSlot = false }: Props) {
  if (!show) return null;
  return (
    <Box
      w="100%"
      h="100%"
      minW={0}
      flexShrink={0}
      borderLeftWidth="0"
      borderColor="whiteAlpha.100"
      bg="#0a0e12"
      display="flex"
      flexDirection="column"
      minH={0}
      maxH="100%"
    >
      {title && (
        <Text
          px={3}
          py={2}
          fontSize="xs"
          fontWeight="700"
          color="whiteAlpha.500"
          textTransform="uppercase"
          letterSpacing="0.06em"
          borderBottomWidth="1px"
          borderColor="whiteAlpha.100"
          flexShrink={0}
        >
          {title}
        </Text>
      )}
      <Box
        flex={1}
        minH={0}
        {...(fillSlot
          ? { overflow: 'hidden', p: 0, display: 'flex', flexDirection: 'column' as const }
          : { overflowY: 'auto', p: 3 })}
      >
        {children ?? (
          <Text fontSize="sm" color="whiteAlpha.500">
            {emptyHint ?? 'Select something to play or view details.'}
          </Text>
        )}
      </Box>
    </Box>
  );
}
